import React, { useState } from 'react'
import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import ReportFooter from '../../ReportsFooter/ReportFooter'

const LocalIncidentsProcessedByWmrcTable = ({
    data,
    isLoading,
    handleColumnSort,
    downloadPDF,
    downloadExcel,
    DisplayDate,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
}) => {

    const [currentRow, setCurrentRow] = useState(null)
    const size = useWindowSize()
    const tableData = data?.data || {};
    
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">
                    Local Incidents Processed By WMRC Report
                </h1>
                <p className="fw-bold my-2">
                    Date :{' '}
                    <span className="fw-normal text-muted ">
                        {DisplayDate?.startDate} to {DisplayDate?.endDate}
                    </span>
                </p>
                <ReactExpandableTable
                    isLoading={isLoading}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    data={tableData}
                    mobileColumns={mobileColumns}
                    handleColumnSort={handleColumnSort}
                    removePagination={true}
                />
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </>
        )
    }

    return (
        <>
            <div>
                <h1 className="mb-4">
                    Local Incidents Processed By WMRC Report
                </h1>
                <p className="fw-bold my-2">
                    Date :{' '}
                    <span className="fw-normal text-muted ">
                        {DisplayDate?.startDate} to {DisplayDate?.endDate}
                    </span>
                </p>
                <p>New Incidents:{data?.newIncidentsSum}</p>
                <ReactDataTable
                    isLoading={isLoading}
                    data={tableData}
                    columns={columns}
                    removePagination={true}
                    handleColumnSort={handleColumnSort}
                />
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </div>
        </>
    )
}

export default LocalIncidentsProcessedByWmrcTable
